export const API_BASE_URL = "https://cms.nag.mv/api/content";
export const CMS_BASE_URL = "https://cms.nag.mv/";
export const FRONTEND_BASE_URL = "https://nag.mv";

export const fetcher = (endpoint, init) =>
  fetch(API_BASE_URL + endpoint, init).then((res) => res.json());
